import timestamp from "shared/renderers/timestamp";
import getNestedAttribute from "shared/renderers/get_nested_attribute";

import Backdraft from "backdraft-app/src/backdraft";

Backdraft.plugin("Renderers", function(plugin) {
  plugin.initializer(function(app) {
    app.renderers = {
      timestamp,
      getNestedAttribute
    };
  });
});
